import Vue from 'vue'
import commonMutations from '@/store/ui/common/mutations'
import utils from './utils'
import { findIndex, isEqual, size, uniq, find } from 'lodash'

const mutations = {
    ...commonMutations,
    setExpandedClustersIds(state, { taxoId, cluster, action }) {
        if (action === 'expand') {
            const data = { ...state.expandedTaxoIds, [taxoId]: uniq([...state.expandedTaxoIds[taxoId], ...utils.getChildrenIds(cluster, true)]) }
            Vue.set(state, 'expandedTaxoIds', data)
        } else if (action === 'close') {
            const idsToRemove = utils.getChildrenIds(cluster, true)
            for (const id of idsToRemove) {
                const indexOfNodeToRemove = findIndex(state.expandedTaxoIds[taxoId], expandedCluster => isEqual(expandedCluster, id))
                Vue.delete(state.expandedTaxoIds[taxoId], indexOfNodeToRemove)
            }
        }
    },
    setExpandedTaxoIds(state, { node, action }) {
        if (action === 'expand') {
            const data = { ...state.expandedTaxoIds, [node.jsonKey.name]: utils.getChildrenIds(node) }
            Vue.set(state, 'expandedTaxoIds', data)
        } else if (action === 'close') {
            Vue.delete(state.expandedTaxoIds, node.jsonKey.name)
        }
    },
    setSelectedAllTaxoIds(state, { taxoId, action }) {
        if (action === 'add') {
            const index = size(state.selectAllTaxoIds)
            Vue.set(state.selectAllTaxoIds, index, taxoId)
        } else if (action === 'remove') {
            const indexOfNodeToRemove = findIndex(state.selectAllTaxoIds, selectedTaxo => isEqual(selectedTaxo, taxoId))
            Vue.delete(state.selectAllTaxoIds, indexOfNodeToRemove)
        }
    },
    setSelectedTaxo(state, { taxoId }) {
        const data = { ...state.selectedClusters, [taxoId]: [] }
        Vue.set(state, 'selectedClusters', data)
    },
    //select ONE cluster
    setSelectedCluster(state, { taxoId, nodeId, action }) {
        if (action === 'add') {
            const index = size(state.selectedClusters[taxoId])
            Vue.set(state.selectedClusters[taxoId], index, nodeId)
        } else if (action === 'remove') {
            const indexOfNodeToRemove = findIndex(state.selectedClusters[taxoId], selectedNode => isEqual(selectedNode, nodeId))
            Vue.delete(state.selectedClusters[taxoId], indexOfNodeToRemove)
        }
    },
    // select SEVERAL clusters at once
    setSelectedClusters(state, { taxoId, nodesIds, action }) {
        let _selectedClusters
        if (action === 'add') {
            _selectedClusters = uniq([...state.selectedClusters[taxoId], ...nodesIds])
            Vue.set(state.selectedClusters, taxoId, _selectedClusters)
        } else if (action === 'remove') {
            Vue.set(state.selectedClusters, taxoId, [])
        }
    },
    setDefaultData(state) {
        Vue.set(state, 'selectedClusters', {})
        Vue.set(state, 'selectAllTaxoIds', [])
        Vue.set(state, 'expandedTaxoIds', {})
    },
    setResetedModifiedClusters(state) {
        Vue.set(state, 'modifiedClusters', [])
    },
    setModifiedClusters(state, { action, id }) {
        const modified = state.modifiedClusters
        if (find(modified, cluster => cluster.id === id)) {
            const index = findIndex(modified, cluster => cluster.id === id)
            modified.splice(index, 1)
        } else {
            const cluster = {
                id: id,
                action: action
            }
            modified.push(cluster)
        }
        Vue.set(state, 'modifiedClusters', modified)
    }
}

export default mutations
